import { Component, OnInit, Injector, AfterViewInit, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { ToolingOperatorService } from '../../../../ve.service';
import { DataGridTemplate } from '../../../../../../shared/data-grid/data-grid.template';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'ga-deliverables-obj-form',
  templateUrl: './ga-deliverables-obj-form.component.html',
  styleUrls: ['./ga-deliverables-obj-form.component.scss']
})
export class GaDeliverablesObjFormComponent extends DataGridTemplate implements OnInit, AfterViewChecked {
  @ViewChild('printContainer', { static: true }) private readonly printContainerRef: ElementRef;
  printFormData = [];

  editForm: UntypedFormGroup;
  workOrdersService: WorkOrdersService;
  toolingOpService: ToolingOperatorService;
  columns: any[];
  numSet: any = 0;
  isSelected = false;

  prevSelectedRows = [];

  constructor(injector: Injector) {
    super(injector);
    this.workOrdersService = injector.get(WorkOrdersService);
    this.toolingOpService = injector.get(ToolingOperatorService);
  }

  ngOnInit() {
    this.controls.excel = false;
    this.controls.delete = false;
    this.controls.edit = false;
    this.controls.add = false;
    this.isClickEdit = true;
    this.editOnselect = true;
    this.selectableSettings.enabled = true;
    this.showSelectAll = false;
    this.isCheckboxDisabled = this.workOrdersService.isViewOnlyWO;
    this.isNotificationsEnabled = false;
    this.gridState.sort = [{ field: 'Description' }];
    this.gridState.group = [{ field: 'Category', dir: 'desc' }];
    this.columnMenu = false;
    this.editForm = this.workOrdersService.deliverablesObjectivesForm;
    this.setColumns();
    this.workOrdersService.isDeliverablesObjFormValid = false;
    this.height = '100%';
  }

  ngAfterViewChecked() {
    // Retaining previous selected rows
    if (this.prevSelectedRows.length > 0) {
      this.prevSelectedRows.forEach(row => { this.selectedRows.push(row); });
      this.prevSelectedRows = [];
    }
    this.setFormValidity();
    this.setPrintData();
  }

  read(opts: any): Promise<any> {
    return !this.data || this.data.length === 0 ? this.getDelObjectives() : Promise.resolve(this.data);
  }

  getDelObjectives(): any {
    return this.toolingOpService.read('?activeOnly=true')
      .then(response => {

        // If Edit and/or Copy view, populate form with data
        if (!this.workOrdersService.isNewWO || this.workOrdersService.isCopyWO) {

          this.workOrdersService.editData.ToolingOperatorInterfaces
            .forEach(element => {
              const index = response.map(x => x.Id).indexOf(element.ToolingOperatorInterfaceId);
              Object.keys(element).forEach(k => {
                response[index][k] = element[k];
              });
              const selectedRow = {
                index,
                dataItem: response[index]
              };
              this.prevSelectedRows.push(selectedRow);
            });

          this.setFormValidity();
        }
        return response;

      });
  }

  create(parentEditDataItem: any): void {
    //this is kept empty on purpose
  }

  edit(dataItem: any): void {
    //this is kept empty on purpose
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    let index = this.data.map(x => x.Id).indexOf(dataItem.Id);
    this.data[index].Objective = dataItem.Objective;

    // Map selected and input Tooling Operator data to main form -
    // Main form is gaAddMultipleForm if user is adding multiple Work Orders
    // Main form is workOrderDetailsForm if user is adding a single new Work Order
    const ctrl = this.workOrdersService.getIsAddMultipleWO
      ? this.workOrdersService.gaAddMultipleForm.get('ToolingOperatorInterfaces')
      : this.workOrdersService.workOrderDetailsForm.get('ToolingOperatorInterfaces');
    const list: any[] = ctrl.value || [];

    index = list.map(x => x.ToolingOperatorInterfaceId).indexOf(dataItem.Id);

    if (index !== -1) { list.splice(index, 1); }

    list.push({
      ToolingOperatorInterfaceId: dataItem.Id,
      Objective: dataItem.Objective
    });

    ctrl.setValue(list);

    return Promise.resolve();
  }

  delete(dataItem: any): Promise<any> {
    const ctrl = this.workOrdersService.getIsAddMultipleWO
      ? this.workOrdersService.gaAddMultipleForm.get('ToolingOperatorInterfaces')
      : this.workOrdersService.workOrderDetailsForm.get('ToolingOperatorInterfaces');
    let list: any[] = ctrl.value || [];
    list = list.filter(e => e.ToolingOperatorInterfaceId !== dataItem.Id);

    ctrl.setValue(list);
    return Promise.resolve();
  }

  readonly canEdit = (dataItem: any): boolean => {
    this.setFormValidity();

    const isSelected = this.selectedRows.some(x => x.dataItem.Id === dataItem.Id);
    if (isSelected) {
      this.save(dataItem, true);
    } else {
      this.delete(dataItem);
    }
    return isSelected;
  }

  setFormValidity() {
    this.numSet = this.selectedRows ? this.selectedRows.length : 0;
    this.workOrdersService.isDeliverablesObjFormValid = this.numSet > 0;
  }


  private setColumns() {
    this.columns = [
      {
        field: 'Description',
        width: 680,
        title: 'Category',
        editable: false,
      },
      {
        field: 'Objective',
        width: 680,
        title: 'Objective',
        autoSelect: true,
        editable: !this.workOrdersService.isViewOnlyWO
      }
    ];
  }

  public setPrintData() {
    this.printFormData = [];
    if (this.workOrdersService && this.data && typeof this.data.find !== 'undefined' && this.workOrdersService.editData
      && this.workOrdersService.editData.ToolingOperatorInterfaces) {
      this.workOrdersService.editData.ToolingOperatorInterfaces.forEach(e => {
        const category = this.data.find(d => d.Id === e.ToolingOperatorInterfaceId);
        if (category) {
          this.printFormData.push({ ...e, ...category });
        }
      });
    }
  }

  public getPrintElement(): ElementRef {
    this.setPrintData();
    return this.printContainerRef;
  }
}
